import { render } from "./ItemSaleStatusSelect.vue?vue&type=template&id=a55682a8"
import script from "./ItemSaleStatusSelect.vue?vue&type=script&lang=ts"
export * from "./ItemSaleStatusSelect.vue?vue&type=script&lang=ts"
script.render = render

export default script